module.exports = require("react-quill");